document.addEventListener('click', function (event) {
  if (!event.target.closest) return;
  var box = event.target.closest('.pv3-yt');
  if (!box || box.querySelector('iframe')) return;

  var id = box.getAttribute('data-yt');
  if (!id) return;

  var frame = document.createElement('iframe');
  frame.setAttribute('src', 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0');
  frame.setAttribute('title', 'Vidéo La Boîte à Cailloux');
  frame.setAttribute('allow', 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture');
  frame.setAttribute('allowfullscreen', '');
  box.innerHTML = '';
  box.appendChild(frame);
});
